// src/services/api.js
const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export async function apiRequest(path, options = {}) {
  const token = localStorage.getItem("esill-token");

  let sessionToken = localStorage.getItem("esill-session");
  if (!sessionToken) {
    sessionToken = crypto.randomUUID();
    localStorage.setItem("esill-session", sessionToken);
  }

  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
  "Content-Type": "application/json",
  ...(token && { Authorization: `Bearer ${token}` }),
  ...(sessionToken && { "x-session-token": sessionToken }),
  ...(options.headers || {}),
},
  });

  const data = await res.json();

  if (!res.ok) {
  const err = new Error(data.message || "API error");
  err.status = res.status;
  err.path = path;
  throw err;
}
  return data;
}
